import type { GeocodedPlace } from "src/GeocodedPlace";

export function isPlaceLast(canonicalName: string, places: GeocodedPlace[]) {
  return canonicalName === places[places.length - 1]?.canonicalName;
}
